/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Alert, Button } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';
import AddIcon from '@mui/icons-material/Add';
import { LanguageContext } from '../../../../libs/Context';
import { MediaContext } from '../..';
import { useNavigate, useParams } from 'react-router-dom';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useSelector } from 'react-redux';

const MediaTopButtons = (props) =>
{
	const { clickedData } = props;
	const { language } = useContext(LanguageContext);
	const { mediaState, setMediaState, tab } = useContext(MediaContext);
	const userId = useParams()?.userId || '';
	const folderId = useParams()?.id || '';
	const { folderData, sharedData, employeeData, trashData, myTemplateData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const visibleFolderData = tab === 0 ? folderData : tab === 1 ? sharedData : tab === 2 ? employeeData : tab === 3 ? trashData : myTemplateData;
	const navigate = useNavigate();

	const handleCreate = () =>
	{
		if (tab === 4)
		{
			const tabVal = tab === 1 ? 'shared' : tab === 2 ? 'employee' : tab === 3 ? 'trash' : tab === 4 ? 'template' : 'folder';

			navigate(folderId ? `/drive/design/${tabVal}/${folderId}` : `/drive/design/${tabVal}`);
		}
		else
		{
			setMediaState({ type: 'setMenuItems', payload: { create: mediaState?.menuItems?.create === 0 ? 1 : 0 } });
		}
	};

	const checkNewBtnExists = () =>
	{
		if (mediaState?.loading) return false;
		else if ([ 0, 4 ].includes(tab))
		{
			return true;
		}

		else if (tab === 1 && folderId && clickedData?.shareAccess === 3)
		{
			return true;
		}
	};

	return (

		<div className='resColRow respdngHSM'>
			<div className='flexGrow pdngVMD'>
				<div className='resColRowMobOnly hideScrollX mediakitjustifyEnd'>
					{(tab === 3) &&
						<div className='flexMinWidthRow pdngRSM'>
							<Alert severity='warning' className='brdrSecondary alignCntr'>{language.file_Days_From_trash}</Alert>
						</div>}
					<div className=' justifyEnd flexAutoRow'>
						{(visibleFolderData?.length > 0 || mediaState?.filter?.split(',')?.length < 5) && !mediaState?.loading &&
							<>
								<div className='flexAutoRow'>
									<Button disableElevation disableRipple variant='outlined' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setMediaState({ type: 'setMenuItems', payload: { listGridview: mediaState?.menuItems?.listGridview === 0 ? 1 : 0 } }); }} onClick={() => setMediaState({ type: 'setMenuItems', payload: { listGridview: mediaState?.menuItems?.listGridview === 0 ? 1 : 0 } })}>
										{mediaState?.menuItems?.listGridview === 0
											? <GridViewIcon/>
											: <ViewListIcon/>}
									</Button>
								</div>
								{(tab === 0 || tab === 1 || (tab === 2 && userId)) &&
								<div className={'flexAutoRow pdngLMD '}>
									<Button variant='outlined' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setMediaState({ type: 'setMenuItems', payload: { toggleFilter: mediaState?.menuItems?.toggleFilter === 0 ? 1 : 0 } }); }} onClick={() => setMediaState({ type: 'setMenuItems', payload: { toggleFilter: mediaState?.menuItems?.toggleFilter === 0 ? 1 : 0 } })}><FilterListIcon/>&nbsp;</Button>
								</div>}
							</>
						}
						{checkNewBtnExists() &&
							<div className='flexAutoRow pointer pdngLMD'>
								<Button tabIndex={0} color='primary' size='medium' className='mobWidth whiteTxt' variant='contained' disableElevation disableRipple
									onKeyUp={(e) => { e.key === 'Enter' && handleCreate(); }}
									onClick={handleCreate}
								>
									<AddIcon />
									{language?.new}
								</Button>
							</div>
						}
					</div>
				</div>

			</div>
		</div>

	);
};

export default MediaTopButtons;